import './App.css';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, Zoom, toast } from 'react-toastify';
import { useState } from 'react';
import Home from './pages/Home';
import AllProducts from './pages/AllProducts';
import SingleProduct from './pages/SingleProduct';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Header from './components/Header';
import UserAccount from './pages/UserAccount';
import Checkout from './pages/Checkout';
import Products from './pages/Products'
import MyOrder from './pages/MyOrder';
import CategoryItem from './pages/CategoryItem';
import BestSelling from './pages/BestSelling';
import MultivetaminsSupplements from './pages/MultivetaminsSupplements';
import BeautySalfCare from './pages/BeautySalfCare';
import Surgical from './pages/Surgical';
import Categories from './pages/Categories';
import Dashboard from './pages/Dashboard';
import DshProducts from './pages/DshProducts';
import DshCategories from './pages/DshCategories';
import DshUsers from './pages/DshUsers';
import DshOrders from './pages/DshOrders';
import Integrations from './pages/Integrations';
import SearchResult from './pages/SearchResult';
import MobileSearchPage from './pages/MobileSearchPage';
import DeliveryLocation from './pages/DeliveryLocation';
import MyPrescription from './pages/MyPrescription';
import Prescriptions from './pages/Prescriptions';
import Sales from './pages/Sales';
import ChangePassword from './pages/ChangePassword';
import Footer from './components/Footer';
import DshContent from './pages/DshContent';
import DshLocation from './pages/DshLocation';
import Support from './pages/Support';
import TrafficReport from './pages/TrafficReport';
import DshCoupons from './pages/DshCoupons';
import Contact from './pages/Contact';
import Profile from './pages/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('isAuthenticated') === "true"
  );
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  // Register User
  const registerUser = (data) => {
    console.log(data);
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', true);
    toast.success('User registered successfully!');
  };

  // Login User
  const loginUser = (data) => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', true);
    toast.success('User logged in successfully!');
  };

  // Logout User
  const logoutUser = () => {
    setIsAuthenticated(false);
    localStorage.setItem('isAuthenticated', false);
    localStorage.removeItem("user_data");
    localStorage.removeItem("auth_token");
    localStorage.removeItem("orderItems");
    localStorage.removeItem("cart");
    localStorage.removeItem('categories');
    localStorage.removeItem('selectedLocation');
    localStorage.removeItem('pincode');
    toast.success('User logged out successfully!');
  };

  // Add to cart function
  const addProductToCart = (product, productCount) => {
    if (isAuthenticated) {
      const cart = JSON.parse(localStorage.getItem('cart')) || [];
      const productExists = cart.find((item) => item.id === product.id);
      if (productExists) {
        productExists.quantity += productCount;
      } else {
        product.quantity = productCount;
        cart.push(product);
      }
      setCart([...cart]);
      localStorage.setItem('cart', JSON.stringify(cart));
      toast.success('Product added to Cart!');
    } else {
      toast.error('Please login first!')
      navigate('/login')
    }
  };
  // Remove from Cart function
  const removeItemsFromCart = (product) => {
    if (window.confirm('Are you sure you want to remove?')) {
      const updatedCart = cart.filter((item) => item.id !== product.id);
      setCart(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      toast.success('Product removed from Cart!');
    }
  };

  // Remove cart items
  const clearCartItems = () => {
    localStorage.removeItem("cart");
    setCart([]);
  };

  return (
    <>
      {/* Renders nothing; resets window scroll on forward navigation so a page
          opened from halfway down a listing starts at its own top. */}
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        transition={Zoom}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
      />
      {(location.pathname !== '/dashboard') && (location.pathname !== '/dashboard-products') &&
        (location.pathname !== '/dashboard-categories') && (location.pathname !== '/dashboard-users') &&
        (location.pathname !== '/dashboard-orders') && (location.pathname !== '/integrations') &&
        (location.pathname !== '/search-suggetion') && (location.pathname !== '/delivery-location') &&
        (location.pathname !== '/prescriptions') && (location.pathname !== '/reports/sales') &&
        (location.pathname !== '/dashboard-content') && (location.pathname !== '/dashboard-location') &&
        (location.pathname !== '/reports/traffic') && (location.pathname !== '/dashboard-coupons') && (
          <>
            <Header isAuthenticated={isAuthenticated} onLogout={logoutUser} cart={cart} />
          </>
        )}
      <Routes>
        <Route path="/" element={<Home onAddToCart={addProductToCart} />} />
        <Route path="/all-products" element={<AllProducts isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path="/products" element={<Products isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path="/product/:id" element={<SingleProduct isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path="/cart" element={<Cart onRemoveProduct={removeItemsFromCart} clearCartItems={clearCartItems} />} />
        <Route path="/login" element={<Login onLoginUser={loginUser} />} />
        <Route path="/signup" element={<Signup onRegisterUser={registerUser} />} />
        <Route path='/account' element={<Profile />} />
        <Route path='/checkout' element={<Checkout onRemoveProduct={removeItemsFromCart} clearCartItems={clearCartItems} isAuthenticated={isAuthenticated} />} />
        <Route path='/my-orders' element={<MyOrder />} />
        <Route path='/my-prescription' element={<MyPrescription />} />
        <Route path='/category/:category' element={<CategoryItem isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path='/best-selling-products' element={<BestSelling isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path='/multivitamins-supplements' element={<MultivetaminsSupplements isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
<Route path='/beauty-self-care' element={<BeautySalfCare isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path='/surgical' element={<Surgical isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path='/categories' element={<Categories />} />
        <Route path='/contact' element={<Contact />} />
        {/* Admin-only routes. The gate lives here rather than in a useEffect inside
            each page — see components/ProtectedRoute.jsx, including why this is
            navigation correctness and not a security boundary (SEC-1 vs SEC-3). */}
        <Route path='/dashboard' element={<ProtectedRoute><Dashboard onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/dashboard-products' element={<ProtectedRoute><DshProducts onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/dashboard-content' element={<ProtectedRoute><DshContent onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/dashboard-categories' element={<ProtectedRoute><DshCategories onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/dashboard-users' element={<ProtectedRoute><DshUsers onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/dashboard-orders' element={<ProtectedRoute><DshOrders onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/dashboard-coupons' element={<ProtectedRoute><DshCoupons onLogout={loginUser} /></ProtectedRoute>} />
        <Route path='/dashboard-location' element={<ProtectedRoute><DshLocation onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/reports/traffic' element={<ProtectedRoute><TrafficReport onLogout={logoutUser} /></ProtectedRoute>} />
        {/* SEC-2: this route previously had no check of any kind. */}
        <Route path='/integrations' element={<ProtectedRoute><Integrations onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/search-result/:searchInput' element={<SearchResult isAuthenticated={isAuthenticated} onAddToCart={addProductToCart} />} />
        <Route path='/search-suggetion' element={<MobileSearchPage />} />
        <Route path='/delivery-location' element={<DeliveryLocation />} />
        <Route path='/support' element={<Support />} />
        <Route path='/prescriptions' element={<ProtectedRoute><Prescriptions onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/reports/sales' element={<ProtectedRoute><Sales onLogout={logoutUser} /></ProtectedRoute>} />
        <Route path='/change-password' element={<ChangePassword />} />
      </Routes>
      {(location.pathname !== '/dashboard') && (location.pathname !== '/dashboard-products') &&
        (location.pathname !== '/dashboard-categories') && (location.pathname !== '/dashboard-users') &&
        (location.pathname !== '/dashboard-orders') && (location.pathname !== '/integrations') &&
        (location.pathname !== '/search-suggetion') && (location.pathname !== '/delivery-location') &&
        (location.pathname !== '/prescriptions') && (location.pathname !== '/reports/sales') &&
        (location.pathname !== '/dashboard-content') && (location.pathname !== '/dashboard-location') &&
        (location.pathname !== '/reports/traffic') && (location.pathname !== '/dashboard-coupons') && (
          <Footer isAuthenticated={isAuthenticated} onLogout={logoutUser} />
        )}

    </>
  );
}

export default App;
